// extracted by mini-css-extract-plugin
export default {"inputHeader":"CreateOrganizationModal_inputHeader__U4R5n","firstHeader":"CreateOrganizationModal_firstHeader__aBdq4"};